import '../../css/components/burger_button.scss'

export default class Header {
    static init() {
        const block = document.querySelector('header')

        if (block) {
            new Header(block)
        }
    }

    constructor(block) {
        this.block = block
        this.bindEvents(block)
    }

    bindEvents(block) {
        const burgerMenu = block.querySelector('.js-burger')
        const menuLink = block.querySelector('.menu--mobile.menu__link')

        this.burgerMenu = burgerMenu

        this.burgerMenu.addEventListener('click', (event) => {
            event.preventDefault()
            this.burgerMenu.classList.toggle('burger--active')
            this.block.querySelector('.header__panel').classList.toggle('header__panel--active')
        })

        if (menuLink) {

            this.menuLink = menuLink

            this.menuLink.addEventListener('click', (event) => {
                event.preventDefault()
                this.burgerMenu.classList.remove('burger--active')
                this.block.querySelector('.header__panel').classList.remove('header__panel--active')
            })
        }

    }
}


